import React from "react";
import PropTypes from "prop-types";
import * as classes from "./AccordionChild.module.css";
import DownArrow from "../../assets/icons/inline/down_arrow.svg";
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS } from "@contentful/rich-text-types";
import OneSidedCard from "../one-sided-card/OneSidedCard";

const AccordionChild = ({
  title,
  text,
  itemOpen,
  setItemOpen,
  finnishLanguage
}) => {
  const handleClick = (ev) => {
    const itemName = ev.target.textContent;
    if (itemOpen === itemName) {
      setItemOpen("");
    } else {
      setItemOpen(itemName);
    }
  };

  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node) => {
        const componentProps = node.data.target;
        const component = componentProps && componentProps.internal.type;
        if (component === "ContentfulOneSidedCard") {
          return (
            <OneSidedCard
              image={componentProps.image}
              position={componentProps.imageSide}
              title={componentProps.title}
              text={componentProps.text}
              finnishLanguage={finnishLanguage}
              accordion
            />
          );
        }
      },
      [BLOCKS.PARAGRAPH]: (node, children) => {
        return <p>{children}</p>;
      },
      [BLOCKS.HEADING_33]: (node, children) => {
        return <h3>{children}</h3>;
      }
    }
  };

  return (
    <AccordionItem className={classes.accordionItem}>
      <AccordionItemHeading onClick={handleClick}>
        <AccordionItemButton className={classes.accordionButton}>
          <h3>{title}</h3>
          <img
            src={DownArrow}
            alt="arrow"
            className={itemOpen === title ? classes.arrowUp : classes.arrowDown}
          />
        </AccordionItemButton>
      </AccordionItemHeading>
      {text && (
        <AccordionItemPanel className={classes.content}>
          {text && renderRichText(text, options)}
        </AccordionItemPanel>
      )}
    </AccordionItem>
  );
};

AccordionChild.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.object.isRequired,
  itemOpen: PropTypes.string,
  setItemOpen: PropTypes.func,
  finnishLanguage: PropTypes.bool.isRequired
};

export default AccordionChild;
